import React, { useState } from 'react';
import useTranslate from '../../../../customHooks/useTranslate';
import Menu from '../../components/Menu';
import SectionTitle from '../../yourProperties/Title';
import DotIcon from '../../../components/DotIcon';
import Icon from '../../../../muiComponents/Icon';
import Tooltip from '../../../../muiComponents/Tooltip';
import Grid from '../../../../muiComponents/Grid';
import GridChild from '../../../../muiComponents/GridChild';
import Card from '../../../../muiComponents/Card';
import Title from '../../../components/Title';
import {
    useContractDetailData,
    useContractDetail,
} from '../../../contextsProperty/ContextContractDetail';
import {
    gridSpacing20,
    gridSpacing30,
    singleXXL_DoubleLG_ColumnGrid,
} from '../../../../utils/commonVariables/grid';
import { Alert } from '@mui/material';
import Button from '../../../../muiComponents/Button';
import { ContractDetailPanelNames } from '../../../../types/contracts/contractTypes';
import MealPlanPanel from './panels/MealPlanPanel';
import DeletePopUp from './DeletePopUp';
import { FeedbackMessages } from '../../../../utils/commonVariables/messages';
import { useNotification } from '../../../../contexts/NotificationsContext';
import LoadingSection from './LoadingSection';
import useUserProfile from '../../../../customHooks/useUserProfile';

const MealPlans = () => {
    const translate = useTranslate();
    const {
        isMainInfoEmpty,
        isBlockedContract,
        openedPanel,
        handleOpenPanel,
        handleOpenMealPlanPanel,
        handleLoadingView,
        handleSaveMealPlan,
        isLoadingView,
    } = useContractDetail();
    const { mealPlans } = useContractDetailData();
    const { setErrorMessage, setSuccessMessage } = useNotification();
    const { readOnlyUser } = useUserProfile();

    const [deletePopUpVisible, setDeletePopUpVisible] = useState('');

    const roomOnlyTxt = useTranslate('room_only');
    const bedNbreakfastText = 'Bed&Breakfast';

    const handleCloseMealPlanPanel = () => {
        handleOpenPanel(null);
    };

    return (
        <>
            {deletePopUpVisible && !readOnlyUser && (
                <DeletePopUp
                    open={!!deletePopUpVisible}
                    onSave={async () => {
                        const deletedMealPlan = mealPlans.find(
                            plan => plan.id === deletePopUpVisible
                        );
                        if (!deletedMealPlan) return;
                        try {
                            handleLoadingView(true);
                            await handleSaveMealPlan({
                                ...deletedMealPlan,
                                Deleted: true,
                            });
                            setSuccessMessage(
                                FeedbackMessages.COMMON_SUCCESS_DELETE
                            );
                        } catch (error) {
                            setErrorMessage(FeedbackMessages.COMMON_ERROR);
                        } finally {
                            handleLoadingView(false);
                            setDeletePopUpVisible('');
                        }
                    }}
                    onCancel={() => {
                        setDeletePopUpVisible('');
                    }}
                ></DeletePopUp>
            )}
            {openedPanel === ContractDetailPanelNames.MEAL_PLANS && (
                <MealPlanPanel
                    open={openedPanel === ContractDetailPanelNames.MEAL_PLANS}
                    onClose={handleCloseMealPlanPanel}
                />
            )}
            <section className='contract-detail__section'>
                <div className='flex flex-between flex-align-center'>
                    <SectionTitle text={'meal_plans'} />
                    {!isMainInfoEmpty && (
                        <Menu
                            menuItems={[
                                {
                                    text: 'add',
                                    icon: 'Add',
                                    disabled: isBlockedContract || readOnlyUser,
                                    onClick: () => {
                                        handleOpenMealPlanPanel({
                                            __isAdded: true,
                                            __isChanged: true,
                                        });
                                    },
                                },
                            ]}
                        />
                    )}
                </div>
                {isLoadingView ? (
                    <LoadingSection />
                ) : mealPlans.length ? (
                    <Grid
                        style={{ width: 'auto' }}
                        columnSpacing={gridSpacing30}
                        rowSpacing={gridSpacing20}
                    >
                        {mealPlans?.map(plan => (
                            <GridChild
                                key={plan.id}
                                gridProps={singleXXL_DoubleLG_ColumnGrid}
                            >
                                <Card
                                    className='flex flex-column gap-20'
                                    style={{
                                        padding: '20px',
                                        minHeight: '110px',
                                    }}
                                >
                                    <div className='flex flex-between flex-align-center'>
                                        <Title key={plan.id}>{plan.name}</Title>
                                        <div className='flex flex-align-center gap-20'>
                                            <div className='flex flex-align-center gap-5'>
                                                <DotIcon
                                                    truthy={plan.enabled}
                                                    falsy={!plan.enabled}
                                                />
                                                <small>
                                                    {plan.enabled
                                                        ? translate('enabled')
                                                        : translate('disabled')}
                                                </small>
                                            </div>
                                            <Menu
                                                menuItems={[
                                                    {
                                                        text: readOnlyUser
                                                            ? 'view'
                                                            : 'edit',
                                                        icon: readOnlyUser
                                                            ? 'Visibility'
                                                            : 'Edit',
                                                        onClick: () => {
                                                            handleOpenMealPlanPanel(
                                                                {
                                                                    ...plan,
                                                                    __isChanged:
                                                                        true,
                                                                }
                                                            );
                                                        },
                                                    },
                                                    {
                                                        text: plan.enabled
                                                            ? 'disabled'
                                                            : 'enabled',
                                                        icon: plan.enabled
                                                            ? 'NotInterested'
                                                            : 'Circle',
                                                        disabled:
                                                            isBlockedContract ||
                                                            readOnlyUser,
                                                        onClick: async () => {
                                                            try {
                                                                handleLoadingView(
                                                                    true
                                                                );
                                                                await handleSaveMealPlan(
                                                                    {
                                                                        ...plan,
                                                                        enabled:
                                                                            !plan.enabled,
                                                                        __isChanged:
                                                                            true,
                                                                    }
                                                                );
                                                                setSuccessMessage(
                                                                    FeedbackMessages.COMMON_SUCCESS_DELETE
                                                                );
                                                            } catch (error) {
                                                                setErrorMessage(
                                                                    FeedbackMessages.COMMON_ERROR
                                                                );
                                                            } finally {
                                                                handleLoadingView(
                                                                    false
                                                                );
                                                                setDeletePopUpVisible(
                                                                    ''
                                                                );
                                                            }
                                                        },
                                                    },
                                                    {
                                                        text: 'delete',
                                                        icon: 'Delete',
                                                        disabled:
                                                            isBlockedContract ||
                                                            readOnlyUser,
                                                        onClick: () => {
                                                            setDeletePopUpVisible(
                                                                plan.id
                                                            );
                                                        },
                                                    },
                                                ]}
                                            />
                                        </div>
                                    </div>
                                    <div className='flex flex-between gap-10'>
                                        <div className='flex flex-start gap-5 '>
                                            <Icon
                                                iconName='Category'
                                                className='text-seconday-700'
                                            />
                                            <Tooltip titleText='type'>
                                                <p>{plan.type}</p>
                                            </Tooltip>
                                        </div>

                                        {(plan.isRoomOnly ||
                                            plan.isBedAndBreakfast) && (
                                            <div className='flex flex-start gap-5 '>
                                                <Icon
                                                    iconName={'Info'}
                                                    className='text-seconday-700'
                                                />
                                                <div
                                                    style={{
                                                        marginRight: '15px',
                                                    }}
                                                >
                                                    {plan.isBedAndBreakfast && (
                                                        <p>
                                                            {bedNbreakfastText}
                                                        </p>
                                                    )}
                                                    {plan.isRoomOnly && (
                                                        <p>{roomOnlyTxt}</p>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </Card>
                            </GridChild>
                        ))}
                    </Grid>
                ) : (
                    <Card
                        className='contract-card__empty flex-center width100perc'
                        style={{ minHeight: '150px', padding: '10px 20px' }}
                    >
                        {isMainInfoEmpty ? (
                            <Alert severity='info' sx={{ width: '100%' }}>
                                {translate('add_main_info_first')}
                            </Alert>
                        ) : (
                            <Button
                                startIcon='Add'
                                disabled={readOnlyUser}
                                onClick={() => {
                                    handleOpenMealPlanPanel({
                                        __isAdded: true,
                                        __isChanged: true,
                                    });
                                }}
                            >
                                {translate('add')}
                            </Button>
                        )}
                    </Card>
                )}
            </section>
        </>
    );
};

export default MealPlans;
